<ng-container *appTranslate="let t">
  @let loggedInV = loggedIn | async;
  <new-ui-error-page
    [errorCode]="loggedInV ? '403' : '401'"
    [errorMessage]="t('accessDenied.title')"
    [errorDescription]="errorMessage ?? (loggedInV ? t('accessDenied.noPermissions') : t('accessDenied.notLoggedIn'))"
  >
    @if (loggedInV) {
      <a pButton [text]="true" severity="warn" [routerLink]="['/']">{{ t("home.title") }}</a>
    } @else {
      <a pButton [text]="true" severity="warn" [routerLink]="['/login']">{{ t("login.title") }}</a>
    }
  </new-ui-error-page>
</ng-container>
